export const ICONS = new Set([
  'msg',
  'view',
  'password',
  'view_off',
  'list-otp',
  'list',
  'discover',
  'account-setting',
  'settings',
  'bug',
  'code',
  'code-circle',
  'favourite',
  'store',
  'wallet',
  'menu',
  'lock',
  'deconnexion',
  'home',
  'arrow',
  'search',
  'cancel',
  'add-circle-half-dot',
  'database-import',
  'rotate',
  'pencil-edit',
  'delete',
  'file-paste',
  'file-validation',
  'user-group',
  'profile',
  'list-marker',
  'circle-arrow',
  'arrow-left',
  'filter',
  'remove-circle',
  'filter',
  'user-status-stroke-rounded',
  'building',
  'building-02',
  'security',
  'security-01',
  'phone',
  'user',
  'password-lock',
  'link-square',
  'pin',
  'user-lock',
  'arrow-left-back',
  'tape-measure',
  'plus',
  'loader',
  'add-circle-rounded',
  'orbit',
  'folder-view',
  'more-vertical',
  'pin-location',
  'road-wayside',
  'hold-phone',
  'more-vertical-circle',
  'logout-02',
  'square-lock-01',
  'draft-invoices',
  'issued-invoices',
  'invoices-received',
  'download-rounded',
  'sent-rounded',
  'package-rounded',
  'calendar-02',
  'calendar-03',
  'user-story',
  'user-switch',
  'lock-password',
  'bitcoin-location',
  'copy',
  'delivery-box',
  'folder-02-stroke-rounded',
  'bag',
  'facture',
  'grid',
  'file-sync',
  'money-receive',
  'search-area',
  'user-account',
  'file-refund',
  'checkmark-circle',
  'level-slider',
  'draft',
  'document-validation',
  'proforma',
  'file-export',
  'delivery-return',
  'circle-arrow-down',
  'invoices-received-white',
  'white-goods-outlets',
  'file-export',
  'text-creation',
  'edit',
  'bitcoin',
  'setup',
  'money-exchange',
  'building-04-stroke-rounded',
  'clock',
  'money-bags',
  'alert-02',
  'invoice-03',
  'invoice-01',
  'arrow-turn',
  'download-circle',
  'image-02',
  'invoice-03',
  'receipt',
  'user-avatar',
  'information-diamond',
  'circle-arrow-left-02',
  'money-bill',
  'invoice-sale',
  'add-invoice',
  'invoice-stroke',
  'ai-programming',
  'key-01',
  'unavailable-stroke',
  'ai-phone',
  'grid-reciept',
  'receipt-tern',
  'information-circle',
  'bitcoin-credit-card',
  'invoice-reciept',
  'book-bookmark',
  'delete-put-back',
  'keyboard-return',
  'arrow-right',
  'cancel-circle',
  'checkmark-circle-stroke'
]);
